import { Box } from "@chakra-ui/react";
import BranchServicesTable, {
  renderBranchArrivalRatesPerServiceCell,
} from "../tables/BranchServicesTable";
import ArrivalRatesPerServiceSummary from "./ArrivalRatesPerServiceSummary";
import ConfiguredReportTable from "../../reports/ConfiguredReportTable";

import { ARRIVAL_RATES_FREQUENCIES } from "../../../store/constants";
import {
  ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
  sortReportRows,
} from "../../../store/renderConfig";
import { buildArrivalRatesPerServiceInsights } from "../../../store/arrivalRatesPerServiceInsights";
import { useSelector } from "react-redux";
import * as defaultSelectors from "../../../store/selectors/defaultSelector";


const BranchServices = ({ reportIndex, data }) => {
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const config = normalizeRenderConfig(renderConfig, {
    columnDefinitions: ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
  });

  return (
    <Box>
      {data.map(({ branchName, servicesData, branchTotalArrivals }, branchIndex) => {
        const title = `${reportIndex || ""}.${branchIndex + 1}. ${branchName}`;
        const branch = { branchName, servicesData, branchTotalArrivals };
        const insights = buildArrivalRatesPerServiceInsights(branch);
        const rows = config.charts.enabled
          ? insights.topChartServices
          : sortReportRows(servicesData, config, {
              columnDefinitions: ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
            });
        return (
          <Box key={`${branchIndex}`}>
            <h2>{title}</h2>
            <ArrivalRatesPerServiceSummary branch={branch} />
            {config.charts.enabled ? (
              <>
                <h3>Top Service Trend Detail</h3>
                {rows.map((data, index) => {
                  return (
                    <BranchServicesTable
                      key={`${branchIndex}-${index}`}
                      index={index}
                      data={data}
                      branchIndex={branchIndex}
                      reportIndex={reportIndex}
                      branchName={branchName}
                      frequency={ARRIVAL_RATES_FREQUENCIES.DAY}
                      renderConfig={config}
                    />
                  );
                })}
              </>
            ) : (
              <Box className="reportTableContainer arrivalRatesPerServiceUnifiedBlock">
                <ConfiguredReportTable
                  columns={ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS}
                  rows={rows}
                  renderConfig={config}
                  renderCell={renderBranchArrivalRatesPerServiceCell}
                />
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default BranchServices;
